import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "../../UI/Progress";

export const TiktokCallback = (): React.JSX.Element => {
  const location = useLocation();

  useEffect(() => {
    const QueryParams = new URLSearchParams(location.search);
    const AuthCode: any = QueryParams.get("auth_code");

    localStorage.setItem("TIKTOK_AUTH_CODE", AuthCode);

    const channel = new BroadcastChannel("tt-auth-channel");
    channel.postMessage({ redirect: location.search });
    channel.close();
    window.close(); // Close the child window
  }, []);
  return <CircularProgress />;
};
